import { ImageTypeEnum } from '@/components/carousel/types/CarouselTypes';
import { KiaPage_Pagebuilder_Blocks_CarCarouselGrid } from '@/graphql/generated/graphql';
import PriceCardGrid from '@/pages/cardgrid/cardgrid';
import { formatFields, getCarModel } from '../utils/format';

const CarCarouselGrid = ({
  blockId,
  selectedCars,
  displayCta,
  displayDescriptions,
  displayPrices,
  displayLeasing,
  imageType,
}: KiaPage_Pagebuilder_Blocks_CarCarouselGrid) => {
  const selected = getCarModel(selectedCars);
  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <PriceCardGrid
        hideControls
        modelCodes={selected.models}
        trimCodes={selected.trims}
        imageType={ImageTypeEnum[imageType]}
        fields={formatFields(
          displayCta,
          displayDescriptions,
          displayPrices,
          displayLeasing,
        )}
      />
    </section>
  );
};

export default CarCarouselGrid;
